import React, { Fragment, useContext, useEffect, useState } from "react";

import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import { Col, Form, FormGroup, Input, Label, Row, Spinner } from "reactstrap";
import { H4, P } from "../AbstractElements";

import LoadingSpinner from "../Components/UI/spinner/index";
import AuthContext from "../_helper/auth";

const Login = ({ setAuthenticated }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [togglePassword, setTogglePassword] = useState(false);
  const [company_id, setCompanyId] = useState("");

  const history = useNavigate();
  const { t, i18n } = useTranslation();
  const { authenticated}=useContext(AuthContext)
  const isAuthenticated = JSON.parse(localStorage.getItem("authenticated"));

  const loginAuth = async (e) => {
    try {
      setLoading(true);
      const res = await axios.post(
        "/web/login",
        {
          email,
          password,
          company_id,
        },
        {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      );

      if (res.status === 200) {
        setAuthenticated(true);
        history(`${process.env.PUBLIC_URL}/home`);
        const token = res.data.token;
        const user = res.data.user;
        let stringObjectUser = JSON.stringify(user);
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        localStorage.setItem("token", token);
        localStorage.setItem("user", stringObjectUser);
        localStorage.setItem("i18nextLng", i18n.language);
        toast.success("login successfully");
      } else {
        toast.error("Incorrect Password or Username!");
      }
    } catch (error) {
      setLoading(false);
      toast.error(`${error.response.data?.message}`);
      if (error.response.status === 403) {
        toast.error(`${error.response.data.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }
  if (authenticated) {
   
    return <Navigate to={`${process.env.PUBLIC_URL}/home`} />;
  }
  return (
    <Fragment>
      <div
        className="p-0 container-fluid"
        dir={i18n.language === "ar" ? "rtl" : "ltr"}>
        <Row>
          <Col className="col-12">
            <div className="login-card">
              <div className="login-main login-tab">
                <Form className="theme-form">
                  <H4>{t("Sign")} . </H4>
                  <P>{t("Enter your email & password to login")}</P>
                  <FormGroup>
                    <Label className="col-form-label">
                      {t("Email Address")}
                    </Label>
                    <Input
                      className="form-control"
                      type="email"
                      required=""
                      onChange={(e) => setEmail(e.target.value)}
                      defaultValue={email}
                    />
                  </FormGroup>
                  <FormGroup className="position-relative">
                    <Label className="col-form-label">{t("Password")}</Label>
                    <Input
                      className="form-control"
                      type={togglePassword ? "text" : "password"}
                      onChange={(e) => setPassword(e.target.value)}
                      defaultValue={password}
                      required=""
                    />
                    <div
                      className="show-hide"
                      onClick={() => setTogglePassword(!togglePassword)}>
                      <span className={togglePassword ? "" : "show"}></span>
                    </div>
                  </FormGroup>
                  <div className="form-group">
                    <label htmlFor="">الرقم التعريفي للشركة</label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={(e) => setCompanyId(e.target.value)}
                    />
                  </div>
                  <div className="form-group mb-0">
                    <div className="checkbox ms-3">
                      <Input id="checkbox1" type="checkbox" />
                      <Label className="text-muted" for="checkbox1">
                        {t("RememberPassword")}
                      </Label>
                    </div>

                    {loading ? (
                      <Spinner />
                    ) : (
                      <button
                        className="btn-block btn-primary btn"
                        disabled={loading ? loading : loading}
                        onClick={(e) => loginAuth(e)}>
                        {t("Login")}
                      </button>
                    )}
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Fragment>
  );
};

export default Login;
